<template>
  <div id="account-info">
    <h1>Account Details</h1>
    <div>
      {{ user.full_name }}<br />
      {{ user.email }}<br />
    </div>
    <br />
    <span v-if="user.isAdmin">
      <h1>Subscription Details</h1>
      <div v-if="subscription.subscription_active">
        Plan Type: {{ subscription.plan_name }}<br />
        Subscription Status: Active<br />
        Subscription Start Date:
        {{ subscription.subscription_start_date.split(" 00:")[0] }}<br />
        Subscription End Date:
        {{ subscription.subscription_end_date.split(" 00:")[0] }} <br /><br />
        <span v-if="subscription.plan_term_cost > 0">
          Next Billing Date:
          {{ subscription.subscription_next_billing_date.split(" 00:")[0]
          }}<br />
          Next Billing Amount: ${{ subscription.plan_billing_term_cost }}<br />
          Total Plan Cost: ${{ subscription.plan_term_cost }} <br /><br />
        </span>
        <span v-if="!subscription.plan_is_unlimited">
          Number of Properties Allowed: {{ subscription.plan_limit_property
          }}<br />
          Number of Users Allowed: {{ subscription.plan_limit_user }}<br />
          <span v-if="subscription.plan_limit_free_item > 0">
            Number of Free Feedback Processed:
            {{ subscription.plan_limit_free_item }}<br />
          </span>
          <br />
          <router-link
            to="/console/account/upgradeplan"
            tag="button"
            class="button button-200"
            >Upgrade Plan</router-link
          >
          <br /><br />
        </span>
      </div>
      <span v-else>
        Your subscription has been cancelled.
        <router-link to="/console/main" tag="button" class="button button-200"
          >Renew Subscription</router-link
        ><br />
      </span>
    </span>
    <h1>Administration</h1>
    <div>
      <router-link
        to="/console/account/useredit"
        tag="button"
        class="button button-200"
        >Change User Info</router-link
      ><br />
      <router-link
        to="/console/account/passwordchange"
        tag="button"
        class="button button-200"
        >Change Password</router-link
      ><br />
      <span v-if="user.isAdmin">
        <router-link
          to="/console/account/users"
          tag="button"
          class="button button-200"
          >Managed Users</router-link
        >
      </span>
    </div>
  </div>
</template>

<script>
import api from "@/api/index";
const apiServiceSubscription = new api.APIServiceSubscription();

export default {
  name: "AccountHome",
  data() {
    return {
      subscription: {}
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
    // ,
    // subscription () {
    //   return this.$store.getters.subscription;
    // }
  },
  created() {
    this.$store.dispatch("getUser");
    this.getUserSubscription();
    // this.$store.dispatch('getUserSubscription');
  },
  methods: {
    getUserSubscription: function() {
      apiServiceSubscription.getUserSubscription().then(data => {
        if (data) {
          this.subscription = data.data;
        }
      });
    }
  }
};
</script>

<style>
#account-info {
  text-align: left;
  margin-left: 20px;
}
#account-info div {
  font-size: 1.2em;
  padding: 15px;
}
</style>
